import React from 'react'
import '../styles/About.css'
import { Link } from 'react-router-dom'

const About = () => {
  return (
    <div className='minHeight100'>
      <div className='hero-section'>
        <h2 className='pagetitle'>ABOUT</h2>
        <div className='hero-content'>
          <div className='hero-image-container'>
            <img src='/headshot.jpg' className='hero-image-about' alt="Rachael Honowitz" />
            <div className='hero-overlay'></div>
          </div>
          <div className='about-hero-text'>
            <h3 className='hero-subtitle'>Founder & CGO</h3>
            <p className='founder-title'>Chief Gifting Officer</p>
            <p className='intro-text'>
              Gift Bags by Rachael is a premier brand connector and trusted industry leader with 20+ years of experience in marketing, events, consulting, product placement, sponsorship opportunities, and more. Rachael started her career at PEOPLE Magazine in 2002, in New York City, where she learned from the best in the business and worked on major events like the SAG Awards, GRAMMYs, Sundance, Super Bowl, Emmys, Fashion Week, Country Music Awards, White House Correspondents' Weekend and more.
            </p>
            <div className='cta-section'>
              <Link className='about-cta-button btn-primary' to="/contact">Contact Rachael</Link>
              <p className='cta-text small'>Get your brand in front of the elite!</p>
            </div>
          </div>
        </div>
        
        <div className='hero-extended-section'>
          <p className='intro-text'>
            She established many relationships in the magazine, media and entertainment landscape and quickly learned the power that celebrities have to influence consumers. Rachael gets products into the hands of these celebrities, managers, agents and VIPS through her relationships and access to various tastemakers in film, music, tv, health and wellness experts and the overall entertainment industry- and in turn, increases her clients brand awareness while creating lasting impressions. Her work has been featured on CNN, Food & Wine, Money Magazine, ESSENCE, Harper's Bazaar, People Magazine, Fortune Magazine, TIME, Politico, KTLA, Extra! People Style Watch, and more.
          </p>
        </div>
      </div>

      <div className='stats-section'>
        <div className='tagline-section'>
          <h3>
            Giving the greatest brands world-class exposure.
          </h3>
        </div>
        <div className='stats-container'>
          <div className='stat-card'>
            <h1 className='stat-number'>50+</h1>
            <div className='stat-label'>Brand Partners</div>
          </div>
          <div className='stat-card'>
            <h1 className='stat-number'>20+</h1>
            <div className='stat-label'>Years Experience</div>
          </div>
          <div className='stat-card'>
            <h1 className='stat-number'>100+</h1>
            <div className='stat-label'>Events Served</div>
          </div>
        </div>
      </div>

      <div className='honors-section'>
        <div className='section-container'>
          <h2 className='about-section-title section-title'>HONORS & RECOGNITION</h2>
          <div className='wash-u-honor'>
            <div className='honor-content'>
              <div className='honor-image'>
                <img src='/honors/wash-u-power-women.jpg' alt="Washington University Olin Power of Women" />
              </div>
              <div className='honor-text'>
                <h3 className='honor-title'>Washington University Olin School of Business</h3>
                <h4 className='honor-subtitle'>Power of Women in Business</h4>
                <p className='honor-description'>
                  An inspiring evening of connection, stories, and celebration that brought together female business leaders to share stories of impact and success with one another.
                </p>
                <a 
                  href='https://www.linkedin.com/posts/wustl-olin-business-school_washuolin-alumnae-womeninbusiness-ugcPost-7242288249165996032-jmV5' 
                  target='_blank' 
                  rel='noopener noreferrer'
                  className='btn-primary'
                >
                  Learn More →
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About